"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var withStyles_1 = require("@material-ui/styles/withStyles");
var styles_1 = require("./styles");
var SubHeader = function (props) { return (React.createElement(Grid_1.default, { container: true, direction: "row", className: props.classes.subheader, justify: "center" },
    React.createElement(Grid_1.default, { container: true, direction: "row", className: props.classes.subheaderContainer }, props.children))); };
exports.default = withStyles_1.default(styles_1.default)(SubHeader);
